<template>
  <div class="card">
    <div class="establishment-list entity-establishments">
      <h3>
        Usuarios
        <vs-button @click="openPopup()">Agregar</vs-button>
      </h3>
      <div class="list">
        <div class="header">
          <div>Nombre y Apellido</div>
          <div>Email</div>
          <div>Fecha de creación</div>
          <div>Establecimientos</div>
          <div></div>
        </div>
        <div class="content">
          <div v-for="user in users" :key="user.id" class="establishment">
            <div>{{ user.firstname }} {{ user.lastname }}</div>
            <div><span class="label-mobile">Email:</span>{{ user.email }}</div>
            <div><span class="label-mobile">Fecha de creación:</span> {{ localeDate(user.createdAt) }}</div>
            <div><span class="label-mobile">Establecimientos</span>{{ (userEsts[user.id]) }}</div> <!--? (userEsts[user.id]) : ' - ' -->
            <div class="actions">
              <button v-if="currentUser.id != user.id" @click="confirmDelete = true; sendUser(user.id)" class="disabled"> <!--destroyUser(user.id)-->
                <vs-icon icon="delete"></vs-icon>
                <span>Borrar</span>
              </button>
              <button @click="editUser(user)">
                <vs-icon icon="edit"></vs-icon>
                <span>Editar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <vs-popup :title="(!editing) ? 'Crear nuevo usuario' : 'Editar Usuario' " :active.sync="popupActive" class="entity-popup">
      <vs-input name="firstname"
            size="large"
            v-validate="'required'"
            label-placeholder="Nombre"
            :danger="this.errors.has('firstname')"
            :danger-text="this.errors.first('firstname')"
            v-model="popupUser.firstname"/>
      <vs-input name="lastname"
            size="large"
            v-validate="'required'"
            :danger="this.errors.has('lastname')"
            :danger-text="this.errors.first('lastname')"
            label-placeholder="Apellido"
            v-model="popupUser.lastname"/>
      <vs-input name="email"
            size="large"
            v-validate="(!editing || emailChanged) ? 'required|email|validateOnDB:user,email' : 'required|email'"
            :danger="this.errors.has('email')"
            :danger-text="this.errors.first('email')"
            label-placeholder="Email"
            v-model="popupUser.email"/>
      <!--  <div v-if="editing">
        <vs-input name="oldPassword"
                    v-validate="'min:6'"
                    :danger="this.errors.has('oldPassword')"
                    :danger-text="this.errors.first('oldPassword')"
                    type="password"
                    size="large"
                    label-placeholder="Contraseña antigua"
                    ref="oldPassword"
                    v-model="popupUser.oldPassword">
        </vs-input>
        <vs-input name="password"
                    v-validate="'min:6'"
                    :danger="this.errors.has('password')"
                    :danger-text="this.errors.first('password')"
                    type="password"
                    size="large"
                    label-placeholder="Nueva contraseña"
                    ref="password"
                    v-model="popupUser.password">
        </vs-input>
        <vs-input name="password_confirmation"
                    v-validate="'confirmed:password'"
                    :danger="this.errors.has('password_confirmation')"
                    :danger-text="this.errors.first('password_confirmation')"
                    type="password"
                    size="large"
                    label-placeholder="Confirmar nueva contraseña"
                    v-model="popupUser.passwordConfirmation">
        </vs-input>
      </div>  --> <br>
      <div class="user-roles">
        <div class="user-roles__title">
          Establecimientos
        </div>
        <div class="user-roles__list">
          <div class="list-header">
            <div>Nombre</div>
            <div>Admin</div>
            <div>Operar</div>
            <div>Lectura</div>
          </div>
          <div class="list-content">
            <div v-for="est in establishments" :key="est.id" class="user">
              <div class="establishment-name">
                {{ est.name }}
              </div>
              <UserRoles :est='est' :user-id="popupUser.id ? String(popupUser.id) : '' " @updated-rol="updateEstablishmentRoles" @updatedUser="clearUser" />
            </div>
          </div>
        </div>

      </div>
      <div class="vs-popup--footer">
        <vs-button color="grey" type="filled"  @click="dismissPopup">Cancelar</vs-button>
        <vs-button :disabled="loading" color="success" type="filled" @click="choose(popupUser)">{{ (!editing) ? 'Crear' : 'Guardar' }}</vs-button>
      </div>
    </vs-popup>

    <vs-popup :active.sync="confirmDelete" title="Eliminar usuario" class="confirm-action" :button-close-hidden="true" >
      <div class="alert danger">
        <vs-icon icon="warning"></vs-icon>
        <span v-if="canDelete">¿Está seguro que desea eliminar el usuario?</span>
        <span v-else>Debe existir al menos un usuario.</span>
      </div>

      <div class="footer">
        <button v-show="canDelete" @click="confirmDelete = false" class="cancel">Cancelar</button>
        <button v-show="canDelete" @click="destroyUser(userToDelete)" class="delete">
          Eliminar
        </button>
        <vs-button v-show="!canDelete" @click="confirmDelete = false" color="success">
          Aceptar
        </vs-button>
      </div>

    </vs-popup>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapMutations, mapState } from 'vuex'
import UserRoles from './UserRoles'

const writeableEstablishments = gql`
  query writeableEstablishments($currentUserToken: String!, $type: String) {
    writeableEstablishments(currentUserToken: $currentUserToken, type:$type) {
      active
      activity
      city
      cuig
      id
      marketRole
      name
      number
      renspa
      ruca
      state
      zipcode
      users {
        canBuy
        canSell
        createdAt
        cuil
        currentTime
        dni
        email
        firstname
        id
        lastname
        offerRole
        organization {
          businessName
          city
          comments
          commercialAddress
          country
          cuit
          email
          id
          incomeTaxSituation
          ivaSituation
          logo
          mainActivity
          phone
          state
          zipcode
        }
        organizationId
        passport
        phone
      }
    }
  }
`
const administrableEstablishments = gql`
  query administrableEstablishments($currentUserToken: String!, $type: String, $scopedUserId: Int) {
    administrableEstablishments(currentUserToken: $currentUserToken, type:$type, scopedUserId: $scopedUserId) {
      active
      activity
      city
      cuig
      id
      marketRole
      name
      number
      renspa
      ruca
      state
      userRole
      zipcode
      users {
        canBuy
        canSell
        createdAt
        cuil
        currentTime
        dni
        email
        establishmentRole
        firstname
        id
        lastname
        offerRole
        organization {
          businessName
          city
          comments
          commercialAddress
          country
          cuit
          email
          id
          incomeTaxSituation
          ivaSituation
          logo
          mainActivity
          phone
          state
          zipcode
        }
        organizationId
        passport
        phone
      }
    }
  }
`
const destroyUser = gql`
  mutation destroyUser($userId: Int!, $currentUserToken: String!){
    destroyUser(userId: $userId, currentUserToken: $currentUserToken) {
      code
      message
      success
    }
  }
`
const updateUser = gql`
  mutation updateUser($userId: Int!, $lastname: String, $firstname: String, $email: String, $password: PasswordInput, $phone: String, $establishmentRoles: [EstablishmentRoleInput!], $currentUserToken: String!){
    updateUser(userId: $userId, lastname: $lastname, firstname: $firstname, email: $email, password: $password, phone: $phone, establishmentRoles: $establishmentRoles, currentUserToken: $currentUserToken) {
      code
      success
      message
    }
  }
`
const backendCreateUser = gql`
  mutation backendCreateUser($lastname: String!, $firstname: String!, $email: String!, $organizationId: String!, $establishmentRoles: [EstablishmentRoleInput!], $currentUserToken: String!) {
    backendCreateUser (lastname: $lastname, firstname: $firstname, email: $email, organizationId: $organizationId, establishmentRoles: $establishmentRoles, currentUserToken: $currentUserToken) {
      code
      success
      message
    }
  }
`
const organizationDetail = gql`
  query organizationDetail($currentUserToken: String, $organizationId: Int){
    organizationDetail(currentUserToken: $currentUserToken, organizationId: $organizationId){
      businessName
      city
      comments
      commercialAddress
      country
      cuit
      email
      id
      establishments {
        active
        city
        cuig
        id
        marketRole
        name
        number
        renspa
        ruca
        state
        zipcode
      }
      ivaSituation
      logo
      mainActivity
      phone
      state
      users {
        createdAt
        email
        firstname
        id
        lastname
        offerRole
        organization {
          businessName
        }
      }
      zipcode
    }
  }
`
export default {
  name: 'user-tab',
  components: {
    UserRoles
  },
  data () {
    return {
      users: [],
      popupUser: {},
      name: '',
      establishmentsRoles: [],
      popupActive:false,
      email: '',
      editing: false,
      rol: '',
      userEsts: [],
      loading: false,
      confirmDelete: false,
      userToDelete: ''
    }
  },
  beforeMount () {
    this.getUsers()
  },
  computed: {
    emailChanged () {
      if (this.editing && this.editing.email != this.popupUser.email) { return true }
      return false
    },
    canDelete(){
      if (this.users.length == 1) {
        return false
      }
      return true
    },
    ...mapState({
      currentUser: state => state.User.currentUser,
      vuexEstablishments: state => state.SignUp.establishments
    }),
    establishments () {
      var buyers = this.vuexEstablishments.buyer
      var sellers = this.vuexEstablishments.seller
      return buyers.concat(sellers)
    }
  },
  watch: {
    popupActive () {
      if (!this.popupActive) {
        this.popupUser = {}
      }
    }
  },
  methods: {
    sendUser(id) {
      this.userToDelete = id
    },
    updateEstablishmentRoles (id, rol) {
      if (this.establishmentsRoles.find(e => e.establishmentId === id)) {
        if (rol) {
          this.establishmentsRoles.find(e => e.establishmentId === id).role = rol
        } else {
          this.establishmentsRoles.splice(e => e.establishmentId === id)
        }
      } else {
        this.establishmentsRoles.push({establishmentId: id, role: rol})
      }
    },
    dismissPopup() {
      this.popupActive = false
    },
    choose(user) {
      this.$validator.validate().then(res => {
        if (res) {
          this.loading = true
          if (!this.editing) {
            this.backendCreateUser()
          } else {
            this.updateUser(user)
          }
        }
      })

    },
    clearUser() {
      this.popupUser = {}
    },
    editUser (user) {
      this.popupActive = true
      this.editing = {...user}
      this.popupUser = {...user}
    },
    openPopup () {
      this.editing = false
      this.popupUser = {}
      this.popupActive = true
    },
    getUserEstablishments (user) {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(writeableEstablishments),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          type: user.offerRole
        }
      }}).then(res => {
        if (!res.data.errors) {
          if (res.data.data.writeableEstablishments.code == "unauthorized") {
            this.$vs.notify({
              title: 'No tiene permisos para realizar esta acción',
              time: 3000,
              //text: 'Por favor intente nuevamente',
              color: '#DE3618',
              position: 'top-right',
              icon: 'error'
            })
          } else {
            this.userEsts[user.id] = this.getAllEstablishments(res.data.data.writeableEstablishments)
            this.$forceUpdate()
          }
        } else {
          console.log(res.data.errors)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getAllEstablishments(arr) {
      return arr.map(establishments => establishments.name).join(', ')
    },
    backendCreateUser() {
      axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(backendCreateUser),
        variables: {
          lastname: this.popupUser.lastname,
          firstname: this.popupUser.firstname,
          email: this.popupUser.email,
          organizationId: String(this.currentUser.organizationId),
          establishmentRoles: this.establishmentsRoles,
          currentUserToken: localStorage.getItem('USER_TOKEN')
        }
      }).then (res => {
        if(!res.data.errors) {
          if (res.data.data.backendCreateUser.code == "unauthorized") {
            this.$vs.notify({
              title: 'No tiene permisos para realizar esta acción',
              time: 3000,
              //text: 'Por favor intente nuevamente',
              color: '#DE3618',
              position: 'top-right',
              icon: 'error'
            })
          } else {
            this.popupActive = false
            this.popupUser = {}
            this.editing = ''
            this.getUsers()
            this.$emit('reloadEstab')
          }
        } else {
          console.log(res.data.errors)
        }
        this.loading = false
      }).catch (err => {
        console.log(err)
        this.loading = false
      })

    },
    destroyUser(id) {
      if (id === this.currentUser.id) { return }
      axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(destroyUser),
        variables: {
          userId: id,
          currentUserToken: localStorage.getItem('USER_TOKEN')
        }
      }).then(res => {
        if (!res.data.errors) {
          if (res.data.data.destroyUser.code == "unauthorized") {
            this.$vs.notify({
              title: 'No tiene permisos para realizar esta acción',
              time: 3000,
              //text: 'Por favor intente nuevamente',
              color: '#DE3618',
              position: 'top-right',
              icon: 'error'
            })
          } else {
            this.confirmDelete = false
            this.getUsers()
          }
        }
      })
    },
    updateUser(user) {
      axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(updateUser),
        variables: {
          userId: user.id,
          lastname: this.popupUser.lastname,
          firstname: this.popupUser.firstname,
          email: this.popupUser.email,
          password: this.popupUser.password,
          establishmentRoles: this.establishmentsRoles,
          currentUserToken: localStorage.getItem('USER_TOKEN')
        }
      }).then(res => {
        if(!res.data.errors) {
          if (res.data.data.updateUser.code == "unauthorized") {
            this.$vs.notify({
              title: 'No tiene permisos para realizar esta acción',
              time: 3000,
              //text: 'Por favor intente nuevamente',
              color: '#DE3618',
              position: 'top-right',
              icon: 'error'
            })
          } else {
            this.popupActive = false
            this.editing = ''
            this.getUsers()
            this.$emit('reloadEstab')
          }
        } else {
          console.log(res.data.errors)
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    getUsers() {
      axios.get(`${process.env.VUE_APP_GRAPH_PATH}`, { params: {
        query: print(organizationDetail),
        variables: {
          organizationId: this.currentUser.organizationId
        }
      }}).then(res => {
        if(!res.data.errors){
          this.users = res.data.data.organizationDetail.users
          this.users.forEach(user => {
            this.getUserEstablishments(user)
          })
        } else {
          console.log(res.data.errors)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    localeDate (str) {
      return new Date(Date.parse(str) + 3.6e+6*3).toLocaleDateString()
      // return (new Date(str)).toLocaleDateString()
    },
  }
}
</script>
